(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabPropertiesController', TabPropertiesController);

    TabPropertiesController.$inject = ['$scope', '$state', 'TabProperties', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function TabPropertiesController ($scope, $state, TabProperties, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicates = pagingParams.predicates;
        vm.transition = transition;
        vm.currentState = "tab-properties";
        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder != null && retrievedOrder != "null") {
            vm.predicates = JSON.parse(retrievedOrder);
        }

        vm.loadAll();
        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        function loadAll () {
            TabProperties.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.tabProperties = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                sort : sort(),
                search: vm.currentSearch
            }, {location: "replace"});
        }

    }
})();
